import { LogLevel } from "@azure/msal-browser";
import { isPrivateLanHost } from "./polyfills/cryptoPolyfill";

export const resolveRedirectUri = () => {
    if (typeof window !== "undefined") {
        const { hostname, origin } = window.location;
        if (isPrivateLanHost(hostname)) {
            return `${origin}/home`;
        }
    }
    return process.env.REACT_APP_REDIRECT_URI || (typeof window !== "undefined" ? `${window.location.origin}/home` : undefined);
};

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: "https://login.microsoftonline.com/organizations",
        redirectUri: resolveRedirectUri()
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        // console.error(message);
                        return;
                    case LogLevel.Info:
                        // console.info(message);
                        return;
                    case LogLevel.Verbose:
                        // console.debug(message);
                        return;
                    case LogLevel.Warning:
                        // console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
